import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { customerReferralStageQueries } from '@/services/pointConfiguration/pointConfiguration.queries';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useManageReferralStage = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('manageReferralStage', {
    onSuccess: async (res) => {
      toast.success(res.message);
      await queryClient.invalidateQueries({ queryKey: customerReferralStageQueries.all() });
      await revalidate(['referralPointInfo']);
    },
    onError: (err) => {
      toast.error(err.message);
    },
  });
  return { mutateAsync, isPending };
};

export default useManageReferralStage;
